module.exports = __webpack_public_path__ + "static/img/index-header.1e87c94.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-header.gif
// module id = 770
// module chunks = 1